function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Main contact name icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M7 8a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6.667A2.667 2.667 0 1 1 4.333 4 2.667 2.667 0 0 1 7 1.333z",
    transform: "translate(-1)",
    style: {
      fill: "#0F1177"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M6 14a6.007 6.007 0 0 0-6 6 .667.667 0 1 0 1.333 0 4.667 4.667 0 0 1 9.333 0A.667.667 0 0 0 12 20a6.007 6.007 0 0 0-6-6z",
    transform: "translate(0 -4.667)",
    style: {
      fill: "#0F1177"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedMain);
export default __webpack_public_path__ + "static/media/detailed-main.578fab65043248441157a411bda6c3bf.svg";
export { ForwardRef as ReactComponent };